export default __webpack_public_path__ + "static/mysql-7f425a5f46cd39ea8dcca06916f36a7d.svg";